import { kubernetesLiveUsageMgmtPostUsersMeOrganisationsCurrentKubernetesByTypeResources } from "../kubernetesLiveUsageMgmtPostUsersMeOrganisationsCurrentKubernetesByTypeResources";
import { RootState } from "@/store/store";
import { ResourceType } from "@/services/cloudchipr.api";

export const k8sLiveUsageResourceMetadataLoading = (
  state: RootState,
  resourceType: ResourceType,
) => {
  return kubernetesLiveUsageMgmtPostUsersMeOrganisationsCurrentKubernetesByTypeResources(
    resourceType,
  )(state)?.isLoading;
};
